// Panel přepisu schůzky vpravo: který přepis a místo je otevřené. `nonce` znovu spustí zvýraznění i u stejného odkazu.
import { useSyncExternalStore } from 'react';
import type { TranscriptRef } from '@sam/shared';

interface State {
  ref: TranscriptRef | null;
  nonce: number;
}

let state: State = { ref: null, nonce: 0 };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function openTranscript(ref: TranscriptRef) {
  state = { ref, nonce: state.nonce + 1 };
  emit();
}

export function closeTranscript() {
  if (!state.ref) return;
  state = { ref: null, nonce: state.nonce };
  emit();
}

export function useTranscriptPanel(): State {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
  );
}
